import { render, staticRenderFns } from "./formNewRangeItem.vue?vue&type=template&id=4ad7c26a"
import script from "./formNewRangeItem.vue?vue&type=script&lang=js"
export * from "./formNewRangeItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports